import { toRefs, watch, reactive, computed } from "vue"
import { v4 as uuidv4 } from 'uuid'
import companyService from "./companyService"
import customerService from "./customerService"
import config from "../../config"
let pathParts = document.location.pathname.split('/')
import getCustomDomain from '../helpers/getCustomDomain'
import dayjs from "dayjs"

import slotsServiceModule from './slotsService'
const slotsService = slotsServiceModule()


import { useTimestamp } from '@vueuse/core'
const now = useTimestamp({ interval: 60000 })

import typedSystem from "./typedSystem"



let storageKeyExtension = ''

//on a custom domain we dont need no extension, because localstorage is bound to domain
if (!getCustomDomain()) {
    //old system
    if (pathParts.length > 2 && pathParts[1] == 'company') {
        storageKeyExtension = pathParts[2]
    }
    if (pathParts.length > 1 && pathParts[1] != 'company') {
        storageKeyExtension = pathParts[1]
    }
    if (!storageKeyExtension) {
        storageKeyExtension = uuidv4()
    }
    storageKeyExtension = '-' + storageKeyExtension
}

let localStorageKey = 'oido-store-v13' + storageKeyExtension

function writeToLocalStorage(data) {
    // console.log('writeToLocalStorage', data, JSON.stringify(data))
    localStorage.setItem(localStorageKey, JSON.stringify(data))
}
function readFromLocalStorage() {
    let data = JSON.parse(localStorage.getItem(localStorageKey))
    // console.log('readFromLocalStorage', data)
    return data
}

var stateTimer = null


const unsubscribeHandles = []

async function teardown() {
    for (let unsubscribeHandle of unsubscribeHandles) {
        await unsubscribeHandle()
    }
    //empty it
    unsubscribeHandles.length = 0
    clear()
}


const state = reactive({
    // const state = reactive({
    initialized: false,
    initializing: false,
    error: null,
    items: {},
    deliveryAddress: {},
    billingAddress: null,
    userSuppliesBillingAddress: false,
    deliveryUsesDifferentAddress: false,
    itemsByCourse: {},
    tipPercentage: 10,
    deliveryType: 'takeaway',
    pickupTimeMode: 'assoonaspossible',
    paymentType: 'online',
    pickupTime: null,
    phone: null,
    email: null,
    customerName: null,
    note: null,
    voucher: null,
    voucherDiscount: null,
    discounts: [],
    activeTags: [],
    errors: {},
    createCustomerIfNoneExists: false
})


function clear() {
    state.items = {}
    state.tipPercentage = 10
    state.itemsByCourse = {}
    state.deliveryType = 'takeaway'
    state.pickupTimeMode = 'assoonaspossible'
    state.pickupTime = null
    state.paymentType = 'online'
    state.note = null
    state.voucher = null
    state.discounts = []
    state.phone = null
    state.email = null
    state.customerName = null
    state.deliveryAddress = state.deliveryAddress ? state.deliveryAddress : {}
    state.billingAddress = null
    state.deliveryUsesDifferentAddress = false
    state.userSuppliesBillingAddress = false
    state.createCustomerIfNoneExists = false
    initItemsByCourse()
}

function emptyTheCart() {
    localStorage.removeItem(localStorageKey)
    if (stateTimer) {
        clearTimeout(stateTimer)
    }
    stateTimer = 'dont'
    clear()

    stateTimer = setTimeout(() => {
        localStorage.removeItem(localStorageKey)
        stateTimer = 'dont'
        clear()
        stateTimer = null
    }, 800)

}


function changeNote(product, note) {
    if (!product || !product.id) {
        console.log('changeNote no product given', product)
        return
    }
    if (!state.items[product.id]) {
        console.log('changeNote no product found', product)
        return
    }
    state.items[product.id].note = note ? note : null
}

function getQuantityForProduct(product) {
    if (!product || !product.id) {
        console.warn('getQuantityForProduct no product given', product)
        return 0
    }

    if (!state.items[product.id]) {
        // console.warn('getQuantityForProduct  product not found', product, state.items)
        return 0
    }
    return state.items[product.id].quantity ? Number.parseInt(state.items[product.id].quantity) : 0
}

//Aggregate quantity for a product across all cart entries — simple lines, variant
//lines (keyed `productId-||-uuid`), and combined-product slot picks. Used to enforce
//stock against the total order, not per cart line, so e.g. 3 separate lines of 1
//beer don't each pass an individual `quantity <= stock` check when stock < 3.
function getTotalQuantityForProductId(productId) {
    if (!productId) return 0
    let total = 0
    for (let key in state.items) {
        let item = state.items[key]
        if (!item) continue
        let qty = Number.parseInt(item.quantity || 0)
        if (!qty) continue
        if (item.productId == productId) {
            total += qty
        }

        //For combined products with stockOfSubproductsAffectCombinedProduct on,
        //each slot pick also consumes a unit of the chosen subproduct's stock.
        if (item.chosen && item.productId) {
            let parentProduct = companyService.getProductById(item.productId)
            if (parentProduct && parentProduct.type == 'combined' && parentProduct.stockOfSubproductsAffectCombinedProduct) {
                for (let slotId in item.chosen) {
                    if (item.chosen[slotId] == productId) {
                        total += qty
                    }
                }
            }
        }
    }
    return total
}

function addProductToBasket(product, chosenItems, addons, options, quantity) {

    if (!quantity) {
        quantity = 1
    }
    if (!product || !product.id) {
        console.log('addProductToBasket no product given', product)
        return 0
    }


    let itemId = product.id + '-||-' + uuidv4()
    if (!state.items[itemId]) {
        state.items[itemId] = { id: itemId }
    }


    state.items[itemId].quantity = state.items[itemId].quantity ? state.items[itemId].quantity + quantity : quantity
    state.items[itemId].chosen = chosenItems
    state.items[itemId].addons = addons && Object.keys(addons).length > 0 ? addons : null
    state.items[itemId].options = options && Object.keys(options).length > 0 ? options : null
    state.items[itemId].productId = product.id

    if (product.type == 'combined') {
        for (let slotId in chosenItems) {
            let chosenProductId = chosenItems[slotId]
            let chosenProduct = companyService.getProductById(chosenProductId)

            if (!state.itemsByCourse[chosenProduct.defaultCourseId]) {
                state.itemsByCourse[chosenProduct.defaultCourseId] = []
            }
            state.itemsByCourse[chosenProduct.defaultCourseId].push({ productId: chosenProduct.id, parentId: product.id, cartItemId: itemId, note: null, slotId: slotId, key: itemId + slotId + 1 })
        }
    } else {
        state.itemsByCourse[product.defaultCourseId].push({ productId: product.id, cartItemId: itemId, note: null, key: itemId + 1 })
    }
}

function deleteItemFromCart(item) {

    if (!item || !item.id) {
        console.log('deleteItemFromCart no item given', item)
        return
    }

    if (!state.items[item.id]) {
        return
    }

    for (let courseId in state.itemsByCourse) {
        state.itemsByCourse[courseId] = state.itemsByCourse[courseId].filter((itemInCourse) => !itemInCourse.cartItemId || itemInCourse.cartItemId != item.id)
    }

    delete state.items[item.id]
}


function countCartItemDown(item) {

    if (!item || !item.id) {
        console.log('countCartItemDown no item given', item)
        return
    }
    if (!state.items[item.id]) {
        return
    }

    let itemsToDelete = null


    if (item.product.type == 'combined') {
        itemsToDelete = Object.values(item.chosen)
    } else {
        itemsToDelete = [item.productId]
    }


    state.items[item.id].quantity = state.items[item.id].quantity && state.items[item.id].quantity > 1 ? state.items[item.id].quantity - 1 : 0


    if (state.items[item.id].quantity <= 0) {
        delete state.items[item.id]
    }

    let newItemsByCourse = {}

    for (let courseId in state.itemsByCourse) {
        newItemsByCourse[courseId] = []
        let courses = state.itemsByCourse[courseId]
        for (let itemInCourse of courses) {

            if (itemsToDelete.includes(itemInCourse.productId) && itemInCourse.cartItemId == item.id) {
                let index = itemsToDelete.indexOf(itemInCourse.productId)
                itemsToDelete.splice(index, 1)
            } else {
                newItemsByCourse[courseId].push(itemInCourse)
            }
        }
    }

    state.itemsByCourse = newItemsByCourse
}


function removeCartItem(itemId) {
    if (!itemId) {
        console.log('removeCartItem no itemId given', itemId)
        return
    }
    if (!state.items[itemId]) {
        return
    }
    delete state.items[itemId]

    let newItemsByCourse = {}

    for (let courseId in state.itemsByCourse) {

        newItemsByCourse[courseId] = []
        let courses = state.itemsByCourse[courseId]
        for (let itemInCourse of courses) {
            if (itemInCourse.cartItemId != itemId) {
                newItemsByCourse[courseId].push(itemInCourse)
            }
        }
    }
    state.itemsByCourse = newItemsByCourse
}

function countCartItemUp(item) {
    if (!item || !item.id) {
        console.log('countCartItemUp no item given', item)
        return 0
    }

    let itemId = item.id
    if (!state.items[itemId]) {
        state.items[itemId] = {}
    }
    state.items[itemId].quantity = state.items[itemId].quantity ? state.items[itemId].quantity + 1 : 1
    state.items[itemId].productId = item.productId

    if (!state.itemsByCourse[item.product.defaultCourseId]) {
        state.itemsByCourse[item.product.defaultCourseId] = []
    }

    if (item.product.type == 'combined') {
        for (let slotId in item.chosen) {
            let chosenProductId = item.chosen[slotId]
            let product = companyService.getProductById(chosenProductId)
            if (!product) {
                continue
            }
            state.itemsByCourse[product.defaultCourseId].push({ productId: product.id, parentId: item.productId, cartItemId: item.id, note: null, slotId: slotId, key: item.id + slotId + state.items[itemId].quantity })
        }
    } else {
        state.itemsByCourse[item.product.defaultCourseId].push({ productId: item.productId, cartItemId: item.id, note: null, key: item.id + state.items[itemId].quantity })
    }
}

/**
 * Repopulates the cart from a previously placed order so the customer can re-order it.
 * Returns { added: <number of line items pushed>, skipped: <number of items whose product no longer exists> }.
 * Items whose product is no longer available are silently skipped.
 */
function repeatOrder(order) {
    let added = 0
    let skipped = 0

    if (!order || !Array.isArray(order.orderItems)) {
        return { added, skipped }
    }

    for (let orderItem of order.orderItems) {
        let product = companyService.getProductById(orderItem.productId)
        if (!product) {
            skipped++
            continue
        }

        let chosenItems = {}
        if (orderItem.chosen && typeof orderItem.chosen == 'object') {
            for (let slotId in orderItem.chosen) {
                let slot = orderItem.chosen[slotId]
                if (slot && slot.chosen && slot.chosen.productId) {
                    chosenItems[slotId] = slot.chosen.productId
                }
            }
        }

        let addons = {}
        if (Array.isArray(orderItem.addons)) {
            for (let addon of orderItem.addons) {
                if (addon && addon.id) {
                    addons[addon.id] = true
                }
            }
        }

        let options = {}
        if (Array.isArray(orderItem.options)) {
            for (let option of orderItem.options) {
                if (!option || !option.id || !Array.isArray(option.values)) continue
                let valueIds = option.values.map((v) => v && v.id).filter(Boolean)
                if (valueIds.length === 1) {
                    options[option.id] = valueIds[0]
                } else if (valueIds.length > 1) {
                    options[option.id] = valueIds
                }
            }
        }

        let quantity = Number.parseInt(orderItem.quantity) || 1
        addProductToBasket(product, chosenItems, addons, options, quantity)
        added = quantity
    }

    return { added, skipped }
}


function totalNumberOfItems() {
    let total = 0
    for (let productId in state.items) {
        let item = state.items[productId]
        if (item.quantity) {
            total = total + item.quantity
        }
    }
    return total
}


function productsInCart() {
    let products = []
    for (let itemId in state.items) {
        let item = state.items[itemId]
        let product = companyService.getProductById(item.productId)
        if (state.items[itemId] && product) {
            products.push(product)
        }
    }
    return products
}

function itemsInCart() {
    let itemsWithProduct = []
    for (let itemId in state.items) {
        let item = state.items[itemId]
        item.id = itemId
        let product = companyService.getProductById(item.productId)
        if (product) {
            item.product = product
        }
        itemsWithProduct.push(item)
    }
    return itemsWithProduct
}


function initItemsByCourse() {

    // console.log('initItemsByCourse!!!!!!!!!', companyService.company.value);

    if (companyService.company && companyService.company.value && companyService.company.value.id) {

        let company = companyService.company.value
        state.tipPercentage = company.defaultTipPercentage

        let activePointofsale = companyService.activePointofsale && companyService.activePointofsale.value ? companyService.activePointofsale.value : null






        let hasOnlinePaymentsEnabled = activePointofsale && activePointofsale.enableOnlinePayment
        //default to online payments, only choose deleviery if takeaway is not enabled (there should always be at least one of them enabled)
        state.paymentType = !hasOnlinePaymentsEnabled ? "offline" : "online"


        //check if allproducts used by cartitems are still valid (exist and are visible)
        //if not simply delete them
        let copiedItemsByCourse = JSON.parse(JSON.stringify(state.itemsByCourse))
        for (let courseId in copiedItemsByCourse) {
            let courses = copiedItemsByCourse[courseId]
            for (let itemInCourse of courses) {
                let cartItem = getCartItemById(itemInCourse.cartItemId)
                if (!cartItem) {
                    continue
                }

                let product = companyService.getProductById(itemInCourse.productId)
                if (!product) {
                    removeCartItem(itemInCourse.cartItemId)
                    continue
                }


                if (cartItem.product && cartItem.product.type == 'combined') {
                    //check if the parentproduct is still available
                    let parentProduct = companyService.getProductById(itemInCourse.parentId)

                    if (!parentProduct) {
                        removeCartItem(itemInCourse.cartItemId)
                        continue
                    }



                    if (itemInCourse.slotId && cartItem.product.slots) {
                        // console.log('cartItem.product', cartItem.product)
                        for (let slot of parentProduct.slots) {
                            // console.log('slot', slot, itemInCourse)
                            if (slot.id == itemInCourse.slotId && slot.availableProducts[itemInCourse.productId]) {
                                // console.log('slot.availableProducts[itemInCourse.productId]', slot.availableProducts[itemInCourse.productId], parentProduct)
                                if (slot.availableProducts[itemInCourse.productId].hidden) {
                                    // console.log('found hidden product',slot.availableProducts[itemInCourse.productId])
                                    removeCartItem(itemInCourse.cartItemId)
                                    continue
                                }
                            }
                        }
                    }
                }
            }
        }




        let availableDeliveryOptions = []
        if (activePointofsale && activePointofsale.enableTableService) {
            availableDeliveryOptions.push('table')
        }

        if (activePointofsale && activePointofsale.enablePickup) {
            availableDeliveryOptions.push('takeaway')
        }
        if (activePointofsale && activePointofsale.enableDelivery) {
            availableDeliveryOptions.push('delivery')
        }

        if (activePointofsale && availableDeliveryOptions.length > 0 && !availableDeliveryOptions.includes(state.deliveryType)) {
            state.deliveryType = availableDeliveryOptions[0]
        }
    }


    if (Object.keys(state.itemsByCourse).length > 0) {
        // console.log('items already initialized');
        return
    }


    state.itemsByCourse = {}

    if (companyService.company && companyService.company.value) {

        let company = companyService.company.value
        state.tipPercentage = company.defaultTipPercentage

        if (!company.courses) {
            return
        }
        for (let course of company.courses) {
            state.itemsByCourse[course.id] = []
        }
    }


    for (let itemId in state.items) {
        let item = state.items[itemId]
        let product = companyService.getProductById(itemId)
        if (!state.itemsByCourse[product.defaultCourseId]) {
            console.log('wrong courseId', product.defaultCourseId)
        }
        for (let i = 0; i < item.quantity; i++) {
            let line = { productId: product.id, cartItemId: itemId, note: null }
            state.itemsByCourse[product.defaultCourseId].push(line)
        }
    }
}

function getCartItemById(cartItemId) {
    if (!cartItemId || !state.items[cartItemId]) {
        return null
    }
    return state.items[cartItemId]
}

function validateCart() {
    state.errors = {}
    if (state.deliveryType == 'takeaway' && state.pickupTimeMode == 'custom') {
        if (!state.pickupTime) {
            state.errors.pickupTime = ['required']
        }
        if (state.pickupTime && dayjs(state.pickupTime).isBefore(dayjs(firstAllowedPickupOrDeliveryDate.value))) {
            state.errors.pickupTime = ['required']
        }
    }
}


function percentageOfAllowedOrderForSlot(numberOfOrders) {
    let company = companyService.company.value
    if (!company || !company.enableSlotLimits) {
        return 0
    }
    if (!numberOfOrders) {
        return 0
    }
    if (!company.allowedNumberOfOrdersPerSlot) {
        return 0
    }

    let percentage = numberOfOrders / company.allowedNumberOfOrdersPerSlot * 100

    return percentage
}

function getSlotsForDay(date) {
    if (!date) {
        return []
    }
    let slots = []
    let slotWidth = 15
    let isDelivery = state.deliveryType == 'delivery'
    let openingHours = isDelivery ? companyService.getDeliveryHoursForDay(date) : companyService.getOpeningHoursForDay(date)
    let minDate = firstAllowedPickupOrDeliveryDate.value


    if (openingHours) {
        for (let range of openingHours) {
            let slotStartTime = dayjs(range.startDate)

            while (slotStartTime.add(slotWidth, 'minutes').isSameOrBefore(range.endDate)) {
                //only push slots that are after the minumum startdate                

                let numberOfOrders = slotsService.getNumberOfOrdersForSlot(slotStartTime)
                let percentage = percentageOfAllowedOrderForSlot(numberOfOrders)
                slots.push({
                    start: slotStartTime,
                    end: slotStartTime.add(slotWidth, 'minutes'),
                    openingHours: range,
                    isInThePast: slotStartTime.isBefore(dayjs()),
                    isSelectable: (!minDate || slotStartTime.isSameOrAfter(minDate, 'minute')) && (percentage < 100),
                    numberOfOrders: numberOfOrders,
                    allocationPercentage: percentage
                })
                slotStartTime = slotStartTime.add(slotWidth, 'minutes')
            }
        }
    }
    return slots
}



function firstPossibleDeliveryDateWithinDeliveryHours(firstPossiblePickupDate) {

    let applicableDeliveryZone = null
    if (typedSystem.orderCalculator && typedSystem.orderCalculator.value) {
        applicableDeliveryZone = typedSystem.orderCalculator.value.getApplicableDeliveryZone()
    }


    if (state.deliveryType != 'delivery' || !applicableDeliveryZone) {
        return firstPossiblePickupDate

    }
    let deliveryTimeConfig = applicableDeliveryZone.zone && applicableDeliveryZone.zone.averageDeliveryTime ? applicableDeliveryZone.zone.averageDeliveryTime : null
    let deliveryTimeUnit = deliveryTimeConfig ? deliveryTimeConfig.unit : 'days'
    let deliveryTime = deliveryTimeConfig && deliveryTimeConfig.value ? Number.parseFloat(deliveryTimeConfig.value) : 0
    let deliveryTimeInMinutes = deliveryTime ? (deliveryTime * ((deliveryTimeUnit == 'days') ? 24 * 60 : (deliveryTimeUnit == 'hours') ? 60 : 1)) : null
    if (!deliveryTimeInMinutes || deliveryTimeInMinutes <= 0) {
        return firstPossiblePickupDate
    }


    let firstPossibleDate = null


    let loopedDate = dayjs(firstPossiblePickupDate)


    // thats a security measure if there is not one big enough deliverytimeSlot to accommodate the whole delivery time
    let numberOfDaysTried = 0
    let maxDaysToTry = 75

    // loop day per day and look for the first opening hours block which is big enough to accommodate the production Time
    // either the complete production time or if its allowed slice it down
    hoursLoop: while (numberOfDaysTried < maxDaysToTry) {
        let deliveryHours = companyService.getDeliveryHoursForDay(loopedDate)

        if (deliveryHours && deliveryHours.length > 0) {
            for (let range of deliveryHours) {

                let startTime = dayjs(range.startDate)
                let endTime = dayjs(range.endDate)

                // as we are getting the opening hours of the whole day, which might be  the day of the firstPossiblePickupDate
                // we have to check if the end and/or start of the opening hour range is after the firstPossiblePickupDate
                if (startTime.isBefore(firstPossiblePickupDate)) {
                    if (endTime.isBefore(firstPossiblePickupDate)) {
                        continue
                    } else {
                        startTime = dayjs(firstPossiblePickupDate)
                    }
                }

                //the amount of available time in the opening slot
                let availableMinutes = endTime.diff(startTime, 'minutes')


                if (availableMinutes > deliveryTimeInMinutes) {
                    firstPossibleDate = startTime.add(deliveryTimeInMinutes, 'minutes')
                    break hoursLoop
                }

            }
        }

        numberOfDaysTried++
        loopedDate = loopedDate.add(1, 'day')
    }


    // console.log('firstPossibleDate', firstPossibleDate.toISOString())
    return firstPossibleDate || null
}


function firstAllowedPickupDateForItem(item) {

    let product = companyService.getProductById(item.productId)
    if (!product) {
        console.error('firstAllowedPickupDateForItem: product not found', item)
        return null
    }


    let productionTime = product.productionTime && product.productionTime.value ? product.productionTime.value : 0
    let productionTimeUnit = product.productionTime && product.productionTime.unit ? product.productionTime.unit : 'days'
    let productionTimeInMinutes = productionTime * ((productionTimeUnit == 'days') ? 24 * 60 : (productionTimeUnit == 'hours') ? 60 : 1)


    let firstPossibleDate = null


    // if we have to fit the production time into opening hours
    if (product.productionTimeIsConstrainedToOpeningHours) {

        let loopedDate = dayjs()
        let accountedForMinutes = 0


        // thats a security measure if we are not allowed to split the production time into several opening hour ranges
        // but there is not one big enough to accommodate the whole production time
        let numberOfDaysTried = 0
        let maxDaysToTry = 75

        // loop day per day and look for the first opening hours block which is big enough to accommodate the production Time
        // either the complete production time or if its allowed slice it down
        hoursLoop: while (numberOfDaysTried < maxDaysToTry) {
            let openingHours = companyService.getOpeningHoursForDay(loopedDate)

            if (openingHours && openingHours.length > 0) {
                for (let range of openingHours) {

                    let startTime = dayjs(range.startDate)
                    let endTime = dayjs(range.endDate)

                    // as we are getting the opening hours of the whole day, which might be today
                    // we have to check if the end and/or start of the opening hour range is in the past
                    if (startTime.isBefore(now.value)) {
                        if (endTime.isBefore(now.value)) {
                            continue
                        } else {
                            startTime = dayjs(now.value)
                        }
                    }
                    //the amount of available time in the opening slot
                    let availableMinutes = endTime.diff(startTime, 'minutes')

                    //the amount of production time we still need to fit somewhere in
                    let stillNeededMinutes = productionTimeInMinutes - accountedForMinutes

                    if (availableMinutes > stillNeededMinutes) {
                        firstPossibleDate = startTime.add(stillNeededMinutes, 'minutes')
                        break hoursLoop
                    }

                    // if we are allowed to split the time into different production time ranges
                    if (product.productionTimeIsSplittable) {
                        accountedForMinutes += availableMinutes
                    }
                }
            }

            numberOfDaysTried++
            loopedDate = loopedDate.add(1, 'day')
        }

    } else {
        //we don't have to fit it into opening hours: just add the required time to now
        firstPossibleDate = dayjs().add(productionTimeInMinutes, 'minutes')
    }

    // console.log('firstPossibleDate', firstPossibleDate.toISOString())
    return firstPossibleDate || null
}

const allowedToAddBillingAddress = computed(() => {
    let customer = customerService.customer && customerService.customer.value ? customerService.customer.value : null
    return !customer || !customer.userMustNotEditAddresses

})
const needsBillingAddress = computed(() => {
    let company = companyService.company && companyService.company.value
    if (!company) {
        return false
    }

    let simplifiedInvoiceTreshold = company.simplifiedInvoiceTreshold ? Number.parseFloat(company.simplifiedInvoiceTreshold) : 0.0
    if (cartBreakdown.value) {
        let total = cartBreakdown.value.total
        if (total > simplifiedInvoiceTreshold) {
            return true
        }
    }

    let activePointofsale = companyService.activePointofsale && companyService.activePointofsale.value ? companyService.activePointofsale.value : null
    if (!activePointofsale) {
        return false
    }
    return Boolean(activePointofsale.collectBillingAddress)
})


const cartBreakdown = computed(() => {
    let company = companyService.company && companyService.company.value
    if (!company) {
        return null
    }
    if (typedSystem.orderCalculator && typedSystem.orderCalculator.value) {
        return typedSystem.orderCalculator.value.getCartBreakDown()
    }
    return null

})


/**
 * If the customer is just short of a cheaper bracket in the currently-applicable delivery zone,
 * suggest how much more to add. Prefers a free bracket if any is reachable by adding net.
 * Returns { addAmount, savings, free } or null.
 */
const deliveryUpgrade = computed(() => {
    if (state.deliveryType != 'delivery') return null
    let calc = typedSystem.orderCalculator && typedSystem.orderCalculator.value
    if (!calc) return null

    let applicable = calc.getApplicableDeliveryZone()
    if (!applicable || !applicable.zone || !applicable.zone.prices) return null

    let currentDeliveryCost = applicable.price
    if (currentDeliveryCost == null || currentDeliveryCost <= 0) return null

    let currentSubtotal = calc.getCombinedSubtotal()
    let currentWeight = calc.getCombinedWeight()

    let best = null
    for (let bracket of applicable.zone.prices) {
        if (bracket.price == null) continue
        if (bracket.minSubtotal == null) continue
        let bracketPrice = Number.parseFloat('' + bracket.price)
        let bracketMin = Number.parseFloat('' + bracket.minSubtotal)
        if (isNaN(bracketPrice) || isNaN(bracketMin)) continue
        if (bracketMin <= currentSubtotal) continue
        if (bracketPrice >= currentDeliveryCost) continue
        let maxWeight = bracket.maxWeight ? Number.parseFloat('' + bracket.maxWeight) : Number.MAX_SAFE_INTEGER
        if (maxWeight < currentWeight) continue

        let candidate = {
            addAmount: bracketMin - currentSubtotal,
            savings: currentDeliveryCost - bracketPrice,
            free: bracketPrice == 0
        }
        // Prefer a free upgrade; otherwise prefer the one with the biggest savings.
        if (!best) {
            best = candidate
            continue
        }
        if (candidate.free && !best.free) {
            best = candidate
            continue
        }
        if (best.free && !candidate.free) continue
        if (candidate.savings > best.savings) best = candidate
    }
    return best
})


const needsDeliveryAddress = computed(() => {

    if (state.deliveryType != 'delivery') {
        return false
    }

    //if its delivery but has no billingaddresse (because the zone doesn't require it and the user didn't add one voluntarily )
    // od the user user wants to add a delivery addresse which differs from the billing address
    if ((!needsBillingAddress.value && !state.userSuppliesBillingAddress) || state.deliveryUsesDifferentAddress) {
        console.log('needsBillingAddress herewego', needsBillingAddress, state.deliveryUsesDifferentAddress)
        return true
    }

    return false
})


/** 
 * returns the first possible date for pickup or delivery (depending on the state)
 * 
 * at first it calculates the first pickupdate for each item. 
 * the farthest individual pickupdate of all items is the earliest pickupdate of the order
 * 
 * If the user selected delivery it adds the expected delivery time of the selected delivery zone.
 * 
 */
const firstAllowedPickupOrDeliveryDate = computed(() => {
    let items = []
    let copiedItemsByCourse = JSON.parse(JSON.stringify(state.itemsByCourse))

    for (let courseId in copiedItemsByCourse) {
        items = items.concat(copiedItemsByCourse[courseId])
    }
    if (!items || items.length == 0) {
        return null
    }

    //get the first possible pickuptime forall items
    let firstPickupDatesOfAllItems = {}
    for (let itemId in items) {
        let item = items[itemId]
        let firstPickupDate = firstAllowedPickupDateForItem(item)
        if (firstPickupDate) {
            firstPickupDatesOfAllItems[itemId] = firstPickupDate
        } else {
            console.error("Couldn't find a pickupdate for item", item)
            return null
        }
    }

    //get the last one from that list
    let dates = Object.values(firstPickupDatesOfAllItems)
    dates.sort((a, b) => b - a)
    let firstPossibleDate = dayjs(dates[0])

    let applicableDeliveryZone = null
    if (typedSystem.orderCalculator && typedSystem.orderCalculator.value) {
        applicableDeliveryZone = typedSystem.orderCalculator.value.getApplicableDeliveryZone()
    }


    console.log('applicableDeliveryZone', applicableDeliveryZone)

    if (state.deliveryType == 'delivery' && applicableDeliveryZone) {
        return firstPossibleDeliveryDateWithinDeliveryHours(firstPossibleDate)
    }


    //look for the first opening/delivery timerange
    let numberOfDaysTried = 0
    let maxDaysToTry = 75
    let loopedDate = dayjs(firstPossibleDate)
    let firstPossibleDateThatsWithinOpeningHours = null


    //loop through future slots to determine the earliest date within the opening hours
    hoursLoop: while (numberOfDaysTried < maxDaysToTry) {
        let availableSlots = getSlotsForDay(loopedDate)
        // console.log('availableSlots',availableSlots)


        for (let slot of availableSlots) {
            // console.log('slot.start', slot.start)
            // console.log('slot.end', slot.end)

            //the date is within opening hours: return the date
            if (firstPossibleDate.isSameOrAfter(slot.start) && firstPossibleDate.isBefore(slot.end)) {
                // console.log('befoe after')
                firstPossibleDateThatsWithinOpeningHours = firstPossibleDate
                break hoursLoop
            }

            //return the first slot start time that's after the date
            if (firstPossibleDate.isSameOrBefore(slot.start)) {
                // console.log(' after')
                firstPossibleDateThatsWithinOpeningHours = slot.start
                break hoursLoop
            }
        }
        numberOfDaysTried++
        loopedDate = loopedDate.add(1, 'day')
    }

    return firstPossibleDateThatsWithinOpeningHours
})


// console.log('cartService', state.initialized ,state.initializing)

state.initialized = false
state.initializing = false

if (!state.initialized && !state.initializing) {
    state.initializing = true

    let savedData = readFromLocalStorage()
    for (let key in savedData) {
        state[key] = savedData[key]
    }
    initItemsByCourse()

    state.initialized = true
    state.initializing = false
}



// set billing address to an empty object as soon its needed or null if not
watch(needsBillingAddress, (needsBillingAddress) => {
    console.log('needsBillingAddress', needsBillingAddress, state.userSuppliesBillingAddress)
    state.billingAddress = needsBillingAddress || state.userSuppliesBillingAddress ? (state.billingAddress ? state.billingAddress : {}) : null
})

//set delivery address to an empty object as soon its needed and its empty
// don't set it to null because if the user enters a deliver address and later on decides that he needs a billing address too, it would delete the delivery address
watch(needsDeliveryAddress, (needsDeliveryAddress) => {
    if (needsDeliveryAddress && !state.deliveryAddress) {
        state.deliveryAddress = {}
    }
})


function copyCustomersAddressesIfNeeded() {
    let customer = customerService.customer && customerService.customer.value ? customerService.customer.value : null
    console.log("customer", customer)
    if (customer) {

        if (customer.name) {
            state.customerName = customer.name
        }
        if (customer.phone) {
            state.phone = customer.phone
        }
        if (customer.email) {
            state.email = customer.email
        }

        if (customer.billingAddress) {
            state.billingAddress = customer.billingAddress
            state.userSuppliesBillingAddress = true
        }

        if (customer.deliveryAddress) {
            state.deliveryAddress = customer.deliveryAddress
            state.deliveryUsesDifferentAddress = true
        } else {
            if (customer.billingAddress) {
                state.deliveryAddress = JSON.parse(JSON.stringify(customer.billingAddress))
                state.userSuppliesBillingAddress = true
            }
        }
    } else {
        state.billingAddress = {}
        state.userSuppliesBillingAddress = false
        state.deliveryAddress = {}
        state.deliveryUsesDifferentAddress = false
        state.customerName = null
        state.phone = null
        state.email = null
    }
}



watch(customerService.customer, (customer, oldValue) => {
    copyCustomersAddressesIfNeeded()
})


watch(companyService.company, (company) => {

    if (!company) {
        console.log('no company!!!!')
        clear()
        window.location.replace(config.url)
        return
    }

    let existingTagIds = company.tags && company.tags.map((tag) => tag.id)
    let cleanedActiveTags = []
    for (let activeTagId of state.activeTags) {
        if (existingTagIds && existingTagIds.includes(activeTagId)) {
            cleanedActiveTags.push(activeTagId)
        }
    }
    state.activeTags = cleanedActiveTags


    //add any new courses to itemsByCourse
    if (company.courses) {
        for (let course of company.courses) {
            if (!state.itemsByCourse[course.id]) {
                state.itemsByCourse[course.id] = []
            }
        }
    }

    //remove any deleted courses        
    let existingCourseIds = company.courses && company.courses.map((course) => course.id)
    if (existingCourseIds) {
        for (let courseId in state.itemsByCourse) {
            if (!existingCourseIds.includes(courseId)) {

                //deleted couse has items in it -> move those to their respective default course
                if (state.itemsByCourse[courseId].length > 0) {
                    for (let item of state.itemsByCourse[courseId]) {
                        let product = companyService.getProductById(item.productId)

                        if (product && product.defaultCourseId && product.defaultCourseId != courseId && state.itemsByCourse[product.defaultCourseId]) {
                            state.itemsByCourse[product.defaultCourseId].push(item)
                        }
                    }
                }
                // deleted course has no items -> simple remove it
                delete state.itemsByCourse[courseId]

            }
        }
    }

    initItemsByCourse()
})

watch(state, async () => {
    if (!stateTimer) {
        stateTimer = setTimeout(() => {
            writeToLocalStorage({
                items: state.items,
                deliveryAddress: state.deliveryAddress,
                billingAddress: state.billingAddress,
                deliveryUsesDifferentAddress: state.deliveryUsesDifferentAddress,
                userSuppliesBillingAddress: state.userSuppliesBillingAddress,
                createCustomerIfNoneExists: state.createCustomerIfNoneExists,
                itemsByCourse: state.itemsByCourse,
                tipPercentage: state.tipPercentage,
                deliveryType: state.deliveryType,
                pickupTimeMode: state.pickupTimeMode,
                pickupTime: state.pickupTime,
                note: state.note,
                // voucher: state.voucher,
                phone: state.phone,
                email: state.email,
                customerName: state.customerName
            })

            stateTimer = null
        }, 500)
    }
}, { deep: true })



export default {
    ...toRefs(state),
    changeNote,
    getQuantityForProduct,
    getTotalQuantityForProductId,
    totalNumberOfItems,
    productsInCart,
    itemsInCart,
    clear,
    emptyTheCart,
    deleteItemFromCart,
    addProductToBasket,
    repeatOrder,
    getCartItemById,
    countCartItemUp,
    countCartItemDown,
    localStorageKey,
    validateCart,
    getSlotsForDay,
    firstAllowedPickupOrDeliveryDate,
    needsBillingAddress,
    needsDeliveryAddress,
    allowedToAddBillingAddress,
    deliveryUpgrade
}


